<form class="p-6 flex flex-col gap-4" (ngSubmit)="save()">
  <h2 class="text-lg font-bold">Etikett umschlüsseln</h2>
  <p class="text-sm text-base-content/70">
    Gleiche XID nachdrucken braucht keine Änderung in HAWK. Die alte XID wird gesperrt und nie wieder vergeben.
  </p>

  <fieldset class="bm-fieldset px-0">
    <label class="bm-fieldset-label">Bisherige XID</label>
    <span class="font-mono">{{ currentXid() || "-" }}</span>

    <label class="bm-fieldset-label" for="xid-rekey-new">Neue XID *</label>
    <input
      id="xid-rekey-new"
      name="newXid"
      class="bm-input w-full font-mono"
      placeholder="XID-0101010"
      autocomplete="off"
      [(ngModel)]="newXid"
      (blur)="normalizeInput()"
      [class.bm-input-error]="newXid.trim() && !normalizedXid"
    />
    @if (newXid.trim() && !normalizedXid) {
      <small class="text-error">Ungültige XID. Erwartet wird XID-NNNNNNN (7 Ziffern) oder ein Bentomax-EPC.</small>
    } @else if (normalizedXid && normalizedXid === currentXid()) {
      <small class="text-error">Das ist die bisherige XID.</small>
    } @else if (newEpc) {
      <small class="text-base-content/70">EPC: <span class="font-mono">{{ newEpc }}</span></small>
    }

    <label class="bm-fieldset-label" for="xid-rekey-reason">Grund</label>
    <input
      id="xid-rekey-reason"
      name="reason"
      class="bm-input w-full"
      placeholder="z. B. Etikett beschädigt"
      [(ngModel)]="reason"
    />
  </fieldset>

  @if (errorMessage) {
    <div class="bm-alert bm-alert-error" role="alert">{{ errorMessage }}</div>
  }

  <div class="bm-modal-action mt-2">
    <button type="button" class="bm-btn" (click)="dialogRef.close(false)">Abbrechen</button>
    <button type="submit" class="bm-btn bm-btn-primary" data-testid="rekey-save" [disabled]="!canSave">
      {{ saving ? "Wird gespeichert..." : "Umschlüsseln" }}
    </button>
  </div>
</form>
